import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import AppUtil from "../../utilities/AppUtil";
import snakecaseKeys from "snakecase-keys";

const _urlPrefix = "/chat";

export const fetchChatPage = createAsyncThunk(
  "chat/get-page",
  async (params) => {
    const result = await httpRequest({
      url: _urlPrefix + "/page",
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params),
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const fetchAddChat = createAsyncThunk(
  "chat/add-chat",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      data: snakecaseKeys(params),
    });
    if (!result) {
      return;
    }
    dispatch(fetchChatPage({ jobId: params.jobId }));
    return result.data;
  }
);

export const fetchUpdateChat = createAsyncThunk(
  "chat/update-chat",
  async (params, { dispatch }) => {
    const request = {
      isIncident: params.isIncident,
      note: params.note
    }
    const result = await httpRequest({
      url: `${_urlPrefix}/${params.id}`,
      method: "PUT",
      data: snakecaseKeys(request),
    });
    if (!result) {
      return;
    }
    dispatch(fetchChatPage(params.queries));
    return result.data;
  }
);

export const fetchDeleteChat = createAsyncThunk(
  "chat/delete-chat",
  async (params, { dispatch }) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/${params.id}`,
      method: "DELETE"
    });
    if (!result) {
      return;
    }
    dispatch(fetchChatPage(params.queries));
    return result.data;
  }
);

const initialState = {
  isLoading: false,
  content: [],
  pagination: {
    totalElements: 0,
    numberOfElements: 0,
    pageSize: 10,
    pageNumber: 1,
    totalPages: 0,
    page: 1
  }
}

const slice = createSlice({
  name: 'chat',
  initialState: initialState,
  extraReducers: {
    [fetchChatPage.pending]: (state) => {
      state.isLoading = true;
      return state;
    },
    [fetchChatPage.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload) {
        state.content = payload.content;
        state.pagination.totalElements = payload.totalElements;
        state.pagination.numberOfElements = payload.numberOfElements;
        state.pagination.totalPages = payload.totalPages;
        state.pagination.page = payload.pageNumber;
        state.pagination = { ...state.pagination };
      }
      state.isLoading = false;
      return state;
    },
    [fetchChatPage.rejected]: (state) => {
      state.isLoading = false;
      return state;
    },
  }
});

export default slice.reducer;

export const getChatPage = createSelector(
  (state) => state.chat.content,
  (content) => content
);

export const getIsLoadingChatPage = createSelector(
  (state) => state.chat.isLoading,
  (isLoading) => isLoading
);

export const getPaginationChatPage = createSelector(
  (state) => state.chat.pagination,
  (pagination) => pagination
);
